/**
 * LiveFlight UI Module
 * Handles loading states, search triggers, and UI flow control
 */

/**
 * UI state properties
 */
export const state = {
  loading: false,

  // Search flow control (redirect-then-search pattern)
  trigger_search: false,
  search_request: {},
};

/**
 * Custom mutations for UI state
 */
export const mutations = {
  set_loading(state, loading) {
    state.loading = loading;
  },

  // Atomic mutation: ends the search flow in a single commit.
  // Prevents 2 separate subscribe handler calls (localStorage writes).
  end_search(state) {
    state.loading = false;
    state.trigger_search = false;
  },
};

/**
 * Keys to persist in local storage
 */
export const localStorageKeys = ["search_request"];
